import { Component, ViewChild, Self, Optional, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NgControl, FormGroupDirective, ControlContainer } from '@angular/forms';
import { faCheck, faTimes } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-yes-no-form-toggle',
  templateUrl: './yes-no-form-toggle.component.html',
  styleUrls: ['./yes-no-form-toggle.component.scss'],
  viewProviders: [
      {
        provide: ControlContainer,
        useExisting: FormGroupDirective
      }
    ]
})
export class YesNoFormToggleComponent implements ControlValueAccessor {

  faCheck = faCheck;
  faTimes = faTimes;

  @Output() change = new EventEmitter<boolean>();
  @Input() isDisabled: boolean = false;

  @ViewChild("group") group : any;

  _value = false;
  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
      return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
}

constructor(
    @Self() @Optional() public ngControl: NgControl,
    public parent: FormGroupDirective
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: any) {
    this._value = value;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  setValue(val: boolean) {
    this.value = val;
    this.change.emit(val);
  }
}